import { fetcher } from '@commenda/utils';
import type { RootfiCompanyUseCase } from '@prisma/client';

export async function updateConnectionSuccess(body: {
  corporation_id: number;
  integration: string;
  id: string;
  useCases?: RootfiCompanyUseCase[];
}): Promise<{
  success: boolean;
  data?: { success: boolean };
  error?: unknown;
}> {
  try {
    const response = await fetcher(`rootfi/connection_success`, {
      method: 'POST',
      body,
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error('Error creating connection:', errorData);
      return {
        success: false,
        error: errorData.message || 'Failed to create connection',
      };
    }

    // Backend returns 204 No Content on success - no body to parse
    if (response.status === 204) {
      return { success: true };
    }

    const data = await response.json();
    return {
      success: true,
      data,
    };
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'Failed to create connection';
    console.error('Failed to establish connection:', error);
    return {
      success: false,
      error: errorMessage,
    };
  }
}
